import React from "react";
import { Key } from "../../1/types";

interface KeyRowProps {
  keyData: Key;
  index: number;
  disabled?: boolean;
  backendUrl: string;
  findKey: (name: string) => Key | undefined;
  handleRemoveKeyx: (id: number) => void;
  handleInputChangeAmont: (index: number, value: number, field: string, step: number) => void;
}

const KeyRow: React.FC<KeyRowProps> = ({
  keyData,
  index,
  disabled,
  backendUrl,
  findKey,
  handleRemoveKeyx,
  handleInputChangeAmont,
}) => {
  // Szukamy aktualnego wpisu klucza w stanie lokalnym; po usunięciu
  // konfiguracja z backendu jeszcze przez moment może zawierać stary rekord.
  // W takim przypadku pomijamy render żeby uniknąć błędu 'undefined.amount'.
  const found = findKey(keyData.keyName);
  if (!found) return null;
  return (
    <div
      key={keyData.keyName}
      className="key-row"
      style={{
        display: "flex",
        flexDirection: "row",
        borderBottom: "1px solid #ddd",
        backgroundColor: "#f5f5f5",
        margin: "0.5% 1% 0.5% 1%",
        alignItems: "center",
        padding: "4px 6px",
      }}
    >
      {disabled || (
        <img
          src={`${backendUrl}/img/XRed.svg`}
          alt="X"
          className="key-delete-btn"
          style={{
            width: "14px",
            height: "14px",
            cursor: "pointer",
            marginLeft: "1%",
          }}
          onClick={() => handleRemoveKeyx(Number(found?.id))}
        />
      )}
      
      {/* Main row container for mobile: name + amount */}
      <div className="key-main-row" style={{ display: "flex", alignItems: "center", gap: "12px", flex: 1 }}>
        <div className="col-name key-col-name" style={{ color: "black" }}>{keyData.keyName}</div>
        
        <div className="col-amount key-col-amount" style={{ color: "black" }}>
          <div className="door-amount-controls">
            {disabled || (
              <div className="inputValueChangerForm">
                <div
                  onClick={() =>
                    handleInputChangeAmont(
                      index,
                      Number(found.amount),
                      "amount",
                      -1
                    )
                  }
                >
                  <img
                    src={`${backendUrl}/img/configurator/minus.svg`}
                    alt="minus"
                    style={{ width: "12px" }}
                  />
                </div>
              </div>
            )}
            <input
              type="number"
              readOnly
              disabled={disabled}
              value={found.amount}
              style={{
                width: "30px",
                border: "none",
                backgroundColor: "#F3F3F3",
                borderBottom: "#B1B1C5 solid 1px",
                textAlign: "center",
              }}
            />
            {disabled || (
              <div className="inputValueChangerForm">
                <div
                  onClick={() =>
                    handleInputChangeAmont(
                      index,
                      Number(found.amount),
                      "amount",
                      1
                    )
                  }
                >
                  <img
                    src={`${backendUrl}/img/configurator/plus.svg`}
                    alt="plus"
                    style={{ width: "12px" }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Empty meta column for alignment with doors table */}
        <div className="col-type key-col-meta" style={{ color: "black" }}></div>
      </div>

      <div className="key-price-row" style={{ display: "contents" }}>
        <div
          className="key-col-net"
          style={{
            fontSize: "12px",
            color: "black",
            padding: "4px 2px",
            textAlign: "right",
          }}
        >
          <span className="price-value">
            {String(keyData.price == null ? "0,0" : keyData.price.toFixed(2)).replace(
              ".",
              ","
            )} €
          </span>
          <span className="price-label"> ohne MwSt.</span>
        </div>
        <div
          className="key-col-gross"
          style={{
            fontSize: "12px",
            color: "black",
            padding: "4px 2px",
            textAlign: "right",
          }}
        >
          <span className="price-value">
            {String(
              keyData.priceBrutto == null ? "0,0" : keyData.priceBrutto.toFixed(2)
            ).replace(".", ",")} €
          </span>
          <span className="price-label"> inkl. MwSt. 19%</span>
        </div>
      </div>
    </div>
  );
};

export default KeyRow;
